<script setup lang="ts">import { ref as _ref } from 'vue';

/**
 *
 * Simple component to display a tooltip when the text is truncated
 *
 */
interface SEllipsisTooltipProps {
  /**
   * Text to display
   */
  content: string;
}
defineProps({
  content: null
});

let tooltipDisabled = _ref(true);

/**
 * Activate tooltip if text is truncated
 * @param e
 */
const addTooltip = (e: MouseEvent) => {
  const el = e.target as HTMLElement;
  if (el.offsetWidth < el.scrollWidth) tooltipDisabled.value = false;
};

/**
 * Deactivate tooltip
 */
const removeTooltip = () => {
  tooltipDisabled.value = true;
};

</script>
<template lang="pug">
.s-ellipsis-tooltip.d-flex.align-center.text-truncate( @mouseover="addTooltip" @mouseleave="removeTooltip" )
  v-tooltip( top :disabled="tooltipDisabled" transition="slide-x-reverse-transition" max-width="500" content-class="text-break")
    template(v-slot:activator='{ on }')
      span.text-truncate( v-on="on" ) {{ content }}
    span {{ content }}
</template>
